import { render, staticRenderFns } from "./DuplicateWarningDialog.vue?vue&type=template&id=1e01c12a&scoped=true&"
import script from "./DuplicateWarningDialog.vue?vue&type=script&lang=ts&"
export * from "./DuplicateWarningDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateWarningDialog.vue?vue&type=style&index=0&id=1e01c12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01c12a",
  null
  
)

export default component.exports